/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Last_DayInputs */

const en_ui_filter_last_day = /** @type {(inputs: Ui_Filter_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`last day`)
};

const de_ui_filter_last_day = /** @type {(inputs: Ui_Filter_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzter Tag`)
};

/**
* | output |
* | --- |
* | "last day" |
*
* @param {Ui_Filter_Last_DayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_day = /** @type {((inputs?: Ui_Filter_Last_DayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_DayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_day(inputs)
	return de_ui_filter_last_day(inputs)
});